export const groupsByTheme = {
  '1': {
    title: 'Маневрирование, построение на проезжей части',
  },
  '2': {
    title:
      'Закон «Об обеспечении безопасности дорожного движения»',
  },
  '3': {
    title:
      'Неисправности и условия, при которых запрещается эксплуатация транспортных средств',
  },
  '4': {
    title: 'Дорожные знаки и дорожная разметка',
  },
  '5': {
    title: 'Перекресток (со знаками, без знаков)',
  },
  '6': {
    title: 'Перекресток (регулируемый, светофор)',
  },
  '7': {
    title: 'Дорожная разметка, остановка, стоянка',
  },
  '8': {
    title: 'Скорость, буксировка, перевозка людей и грузов',
  },
  '9': {
    title: 'Предупредительные сигналы, специальные сигналы',
  },
  '10': {
    title:
      'Безопасность жизни участников дорожного движения',
  },
};
